/// <amd-module name="VSSUI/Components/Tabs/TabBadge" />
import * as React from "react";
import { Pill, PillSize } from "VSSUI/Pill";
import { ITabBadgeProps } from "VSSUI/Tabs.Types";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";

export const TabBadge: React.SFC<ITabBadgeProps> = props => {
    const { children, className, containsCount = true, tooltipProps } = props;
    let badge = (
        <Pill
            className={css(className, "bolt-tab-badge")}
            containsCount={containsCount}
            size={PillSize.compact}
            contentClassName="text-ellipsis"
            excludeFocusZone={true}
            excludeTabStop={true}
        >
            {children}
        </Pill>
    );

    if (tooltipProps) {
        badge = <Tooltip {...tooltipProps}>{badge}</Tooltip>;
    }
    return badge;
};
